import { Option, ReadonlyArray } from "@morphism/fp";

import { Graph, gql } from "~/Graph";

// export type Media = { id: ID, type: {}};
export namespace Media {
  export type Fragment = Graph.Generated.Media__HasMany;
  export namespace Fragment {
    export const document = () => gql`
      ${Graph.Errors.Fragment.document()}
      ${Image.Fragment.document()}

      fragment Media__Raw on Media {
        id
        type {
          ... on Media__Type__Image {
            ...Image
          }
        }
      }

      fragment Media on Media__HasMany {
        media {
          ...Error
          ...Media__Raw
        }
      }
    `;
  }

  export type Images = readonly Image[];
  export type Image = { readonly uri: string };
  export namespace Image {
    export namespace Fragment {
      export const document = () => gql`
        fragment Image on Media__Type__Image {
          file {
            uri
          }
        }
      `;
    }

    export const decode = (encoded: Fragment) => ({
      images: pipe(
        encoded.media ?? [],
        ReadonlyArray.filterMap((media) =>
          media.__typename === "Media" && "file" in media.type
            ? Option.some(media.type.file)
            : Option.none
        )
      ),
    });
  }
}
